import ConfirmEmailSentView from "./ConfirmEmailSentView";
export default ConfirmEmailSentView;
